/**
 * `company` translations, for every locale -- the read-only Company page and
 * the company-identity panel on the HR record. The nav key `app.company`
 * went with the Company page.
 */
export const company = {
  mn: {
    company: {
      title: 'Компани',
      intro: 'Бид дөрвөн компанийн нэрээр нэхэмжлэх гаргадаг. Ажилтан, цагийн хуваарь, цалин нь нэг байгууллагад нэгдсэн.',
      registrationNo: 'Регистрийн дугаар',
      vatNo: 'НӨАТ-ын дугаар',
      noVat: 'НӨАТ төлөгч биш',
      phone: 'Утас',
      email: 'И-мэйл',
      headcount: 'Ажилтан',
      headcountValue: '{{count}} идэвхтэй ажилтан',
      defaultBadge: 'Үндсэн',
      retiredBadge: 'Идэвхгүй',
      totalsTitle: 'Нийт',
      distinctTotal: 'Дор хаяж нэг компанид холбогдсон',
      distinctHint: 'Хоёр компанид холбогдсон хүнийг нэг удаа тоолно.',
      unlinked: 'Компанид холбогдоогүй',
      activeStaff: 'Идэвхтэй ажилтан',
      addressesTitle: 'Хаяг',
      addressesHint: 'Дөрвөн компанид нийтлэг.',
      headOffice: 'Төв оффис',
      branch: 'Салбар',
      none: '—',
      loadError: 'Компанийн мэдээллийг ачаалж чадсангүй.',
      panelTitle: 'Компани',
      panelHint: 'Энэ хүн аль компанийн нэрээр ажилладаг.',
      panelNone: 'Компанид холбогдоогүй',
      panelUnknown: 'Компанийн холбоосыг ачаалж чадсангүй.',
      linked: 'Холбогдсон',
      notLinked: 'Холбогдоогүй',
    },
  },
  en: {
    company: {
      title: 'Company',
      intro: 'We invoice under four company names. Staff, roster and payroll are shared across one organization.',
      registrationNo: 'Registration no.',
      vatNo: 'VAT no.',
      noVat: 'Not VAT-registered',
      phone: 'Phone',
      email: 'Email',
      headcount: 'Headcount',
      headcountValue: '{{count}} active staff',
      defaultBadge: 'Default',
      retiredBadge: 'Retired',
      totalsTitle: 'Totals',
      distinctTotal: 'Linked to at least one company',
      distinctHint: 'Someone linked to two companies is counted once here.',
      unlinked: 'Not linked to any company',
      activeStaff: 'Active staff',
      addressesTitle: 'Addresses',
      addressesHint: 'Shared by all four companies.',
      headOffice: 'Head office',
      branch: 'Branch',
      none: '—',
      loadError: 'Could not load the company details.',
      panelTitle: 'Companies',
      panelHint: 'Which company names this person works under.',
      panelNone: 'Not linked to any company',
      panelUnknown: 'Could not load the company links.',
      linked: 'Linked',
      notLinked: 'Not linked',
    },
  },
  ru: {
    company: {
      title: 'Компания',
      intro: 'Мы выставляем счета от четырёх юридических лиц. Персонал, график и зарплата общие в одной организации.',
      registrationNo: 'Рег. номер',
      vatNo: 'Номер НДС',
      noVat: 'Не плательщик НДС',
      phone: 'Телефон',
      email: 'Эл. почта',
      headcount: 'Численность',
      headcountValue: 'Активных сотрудников: {{count}}',
      defaultBadge: 'Основная',
      retiredBadge: 'Неактивна',
      totalsTitle: 'Итого',
      distinctTotal: 'Привязаны хотя бы к одной компании',
      distinctHint: 'Сотрудник, привязанный к двум компаниям, считается здесь один раз.',
      unlinked: 'Не привязаны ни к одной компании',
      activeStaff: 'Активные сотрудники',
      addressesTitle: 'Адреса',
      addressesHint: 'Общие для всех четырёх компаний.',
      headOffice: 'Головной офис',
      branch: 'Филиал',
      none: '—',
      loadError: 'Не удалось загрузить данные компании.',
      panelTitle: 'Компании',
      panelHint: 'От имени каких компаний работает этот сотрудник.',
      panelNone: 'Не привязан ни к одной компании',
      panelUnknown: 'Не удалось загрузить привязки к компаниям.',
      linked: 'Привязан',
      notLinked: 'Не привязан',
    },
  },
}
